import {UnitsType} from "@pg-design/range-module";

import {CalculatorValueType} from "../types/CalculatorValueType";
import {ICalculatorOptions} from "../types/ICalculatorOptions";
import {RangeOptionNameType} from "../types/RangeOptionNameType";

export const InstallmentCalculatorRangesOptions: ICalculatorOptions[] = [
    {
        title: "Cena nieruchomości",
        name: RangeOptionNameType.PRICE,
        desc: "Ustaw kwotą, którą zamierzasz wydać na mieszkanie",
        values: {
            lower: 50000,
            upper: 8000000,
            init: 400000
        },
        uniteType: UnitsType.NUMBERS,
        step: 10000,
        valueType: CalculatorValueType.PRICE
    },
    {
        title: "Wkład własny",
        name: RangeOptionNameType.CONTRIBUTION,
        desc: "Większość banków wymaga wkładu własnego na poziomie 20% ceny nieruchomości",
        values: {
            lower: 10,
            upper: 90,
            init: 20
        },
        uniteType: UnitsType.PERCENTS,
        step: 5,
        valueType: CalculatorValueType.CONTRIBUTION
    },
    {
        title: "Okres kredytowania",
        name: RangeOptionNameType.PERIOD,
        desc: "Rata miesięczna jest zależna od długości okresu kredytowania",
        values: {
            lower: 5,
            upper: 35,
            init: 30
        },
        step: 5,
        uniteType: UnitsType.YEARS,
        valueType: CalculatorValueType.PERIOD
    }
];

export const getInstalmentRangesFromName = (name: RangeOptionNameType) => {
    const option = InstallmentCalculatorRangesOptions.find((el) => el.name === name);
    return {min: option?.values.lower || 0, max: option?.values.upper || 0};
};
